import React, { Component } from 'react';
import { Grid, Button, Box, Hidden, Typography, Theme, styled } from '@quillbot/design-system';
import withStyles from '@mui/styles/withStyles';
import createStyles from '@mui/styles/createStyles';
import withTheme from '@mui/styles/withTheme';
import { withRouter } from 'next/router';
import { connect } from 'react-redux';
import HerosectionNew from 'src/mics/components/try/HeroSectionNew';
import AutoPlaySwipeableViews from '@Common/quillElements/AutoPlaySwipeableViews';
import LoadWithAnimation from 'src/_common/components/LoadWithAnimation';
import { RootState } from 'src/_common/models/redux/store';
import { User } from 'src/authentication/models/store';
import Link from 'next/link';
import { DEVICE_VIEWPORTS } from 'config/constants';
import ABTest from '@Common/hoc/ABTest';
import Track from './handlers/track';
import LinearProgress from '@Common/components/LinearProgressBar';
import { PremiumModeSliders } from './components/PremiumModeSlides';
import { PauseIcon, ThumbsUpIcon } from 'src/_common/quillElements/icon';
import PremiumVsFreeFeatureTable from './components/PremiumVsFreeFeatureTable';
import PremiumVsFreeFeatureTableV1 from './components/PremiumVsFreeFeatureTableV1';
import CircularGoldButton from './components/CircularGoldButton';

const styles = createStyles((theme: Theme) => ({
  tabPillBox: {
    width: '300px',
  },

  premuimSliderBox: {
    textAlign: 'center' as 'center',
    padding: '0px 15px',
    maxWidth: '450px',
    margin: 'auto',
    [theme.breakpoints.down('sm')]: {
      maxWidth: '380px',
    },
  },

  premuimSliderText: {
    textAlign: 'left' as 'left',
    padding: '5px 15px',
    margin: 'auto',
    '& h3': {
      margin: '0px 0px',
      fontSize: '17px',
    },
    '& p': {
      margin: '0px 0px',
      fontSize: '16px',
    },
    [theme.breakpoints.down('sm')]: {
      padding: '0px 15px',
    },
  },

  /* =================== */

  tabHolderBox: {
    borderRadius: '6px',
    padding: '9px 16px 14px',
    maxWidth: '453px',
    width: '100%',
    margin: '0px 0px 7px',
    cursor: 'pointer',
    '& h3': {
      margin: '0px 0px',
      fontSize: '18px',
      fontWeight: 'bold' as 'bold',
    },
    '& p': {
      margin: '5px 0px 10px',
      lineHeight: '22px',
    },

    [theme.breakpoints.down(1175)]: {
      maxWidth: '90%',
      margin: '0px auto 20px auto',
    },

    [theme.breakpoints.down(1050)]: {
      maxWidth: '90%',
      margin: '0px auto 20px auto',
    },
  },

  imgAnimation: {
    'transition-delay': '2s, 4ms',
    maxWidth: '100%',
  },

  tabHolderBoxActive: {
    '& h3': {
      color: theme.palette.text.primary,
    },
  },

  /* =========== premiumBox ========== */

  tabHolderMain: {
    paddingTop: '15px',
    [theme.breakpoints.down('md')]: {
      paddingTop: '0px',
    },
  },

  /* ====== premium bottom section css ======= */
  premiumTopsection: {
    backgroundImage: `url('./images/theme/${theme.palette.mode}/premiumPage/topBg.svg')`,
    backgroundSize: 'auto 99% ',
    backgroundPosition: 'left bottom',
    backgroundRepeat: 'no-repeat',
    [theme.breakpoints.down(400)]: {
      backgroundSize: ' auto 75%',
    },
    [theme.breakpoints.down('md')]: {
      backgroundSize: ' auto 100%',
      paddingTop: '35px',
    },
  },
  premiumTitleHolder: {
    paddingTop: '20px',
  },

  premiumBottomSectionHolder: {
    // backgroundColor: theme.palette.background.default,
  },

  premiumBottomSection: {
    backgroundImage: `url('./images/theme/${theme.palette.mode}/premiumPage/bottomBg.svg')`,
    backgroundSize: '100% auto',
    backgroundPosition: 'center bottom',
    backgroundRepeat: 'no-repeat',
    padding: '26px 0px 60px',
    textAlign: 'center' as 'center',
    [theme.breakpoints.down('md')]: {
      padding: '10px 0px 40px',
    },
  },
  colorPrimary: {
    backgroundColor: '#DCDCDC',
  },
  barColorPrimary: {
    backgroundColor: '#252525',
  },

  mobileStepperDot: {
    backgroundColor: '#fff',
  },
  dotActive: {
    backgroundColor: theme.palette.primary.main,
  },

  pageTitleMobile: {
    [theme.breakpoints.down('md')]: {
      fontSize: '23px',
      padding: '2px 10px',
      lineHeight: '30px',
      marginTop: '0px',
    },
  },

  premiumTopButtonHolder: {
    textAlign: 'center',
    marginBottom: '70px',
    [theme.breakpoints.down('md')]: {
      marginBottom: '0px',
    },
  },

  sectionTitle: {
    fontWeight: 'normal',
    fontSize: '26px',
    [theme.breakpoints.down('md')]: {
      fontSize: '20px',
      padding: '0px 25px',
    },
  },

  upgradeBtn: {
    borderRadius: '20px',
    fontSize: '17px',
    paddingLeft: '20px',
    fontWeight: 600,
    paddingRight: '20px',
    marginTop: '13px',
    maxWidth: '365px',
    minHeight: '44px',
    width: '100%',
    [theme.breakpoints.down('sm')]: {
      fontSize: '14px',
      maxWidth: '244px',
    },
  },

  premiumBtnBottom: {
    maxWidth: '250px',
    borderRadius: '25px',
    marginBottom: '32px',
    width: '100%',
    minHeight: '44px',
    fontWeight: 600,
    fontSize: '17px',
    color: theme.palette.primary.contrastText,
  },

  premiumBottomTextHolder: {
    marginTop: '35px',
    [theme.breakpoints.down('sm')]: {
      marginTop: '25px',
    },
  },

  assuranceDescription: {
    marginTop: '8px',
  },
}));

// const firestore = Firestore.getInstance();

const PremiumFeatureTabImages = (theme: Theme, idx: number) => {
  const paths = [
    `images/theme/${theme}/premiumPage/newAvailableWord.svg`,
    `images/theme/${theme}/premiumPage/synonym.svg`,
    '/images/theme/commonImages/plagiarismChecker/plag-premium.svg',
    `images/theme/commonImages/premiumPage/comparisonTable.svg`,
  ];
  return paths[idx];
};

const SyledButton = styled(Button)`
  && {
    background: ${({ theme }: { theme: Theme }) => theme.palette.secondary.main};
    font-weight: 600;
  }
`;

const StyledTextContainer = styled(Box)`
  && {
    padding-bottom: 24px;
    // color: #252525;
    @media ${DEVICE_VIEWPORTS.xs} {
      padding: 1em 2em;
    }
  }
`;

//@TODO please fix any
interface IProps {
  user: User;
  classes: any;
  router: any;
  theme: any;
}

interface IState {
  premiumFeatureTabIndex: number;
  componentLoad: boolean;
}

class PremiumPage extends Component<IProps, IState> {
  constructor(props: IProps) {
    super(props);
    this.state = {
      premiumFeatureTabIndex: 0,
      componentLoad: false,
      // 'worldFlipper.png'
    };
  }

  componentDidMount = () => {
    document.onreadystatechange = () => {
      if (document.readyState === 'complete') {
        this.setState({
          componentLoad: true,
        });
        setInterval(() => {
          this.setState((state) => {
            return {
              premiumFeatureTabIndex:
                state.premiumFeatureTabIndex === 3 ? 0 : state.premiumFeatureTabIndex + 1,
            };
          });
        }, 5000);
      }
    };
  };

  render() {
    const { classes } = this.props;
    const { premiumFeatureTabIndex, componentLoad } = this.state;
    return (
      <>
        <Grid container>
          <Grid item xs={12}>
            <div className="container">
              <Grid container>
                <Grid
                  item
                  xs={12}
                  className={classes.premiumTitleHolder}
                  style={{ textAlign: 'center' }}
                >
                  <h1 className={`${classes.pageTitleMobile} pageTitle`}>
                    Save time and write with confidence
                  </h1>
                </Grid>
              </Grid>

              {!this.props.user?.premium && (
                <Grid container>
                  <Grid item xs={12} className={classes.premiumTopButtonHolder}>
                    <Link href={{ pathname: '/upgrade', query: { referrer: 'premiumPage' } }}>
                      <Button
                        variant="contained"
                        color="primary"
                        className={classes.upgradeBtn}
                        onClick={() => Track.upgradeLinkClicked('topSection')}
                      >
                        Upgrade to QuillBot Premium
                      </Button>
                    </Link>
                  </Grid>
                </Grid>
              )}
            </div>

            <Grid container className={classes.premiumTopsection}>
              <Hidden only={['lg', 'md', 'xl']}>
                <Grid container>
                  <Grid item xs={12} style={{ position: 'relative', paddingBottom: '50px' }}>
                    {/* <!-- ======== slider start from here ========== --> */}
                    <AutoPlaySwipeableViews
                      controlBtnStyle={{ display: 'none' }}
                      autoplay={true}
                      // showControlOnEnd
                      // showBottomControl
                      mobileStepperClasses={{
                        dot: classes.mobileStepperDot,
                        dotActive: classes.dotActive,
                      }}
                      mobileStepperStyle={{ backgroundColor: 'transparent' }}
                    >
                      <Box className={classes.premuimSliderBox}>
                        <img
                          src={`images/theme/${this.props.theme.palette.mode}/premiumPage/newAvailableWord.svg`}
                          className="lazyload"
                          alt="available Words"
                          style={{ maxWidth: '100%' }}
                        />
                        <Box className={classes.premuimSliderText}>
                          <h3>Increase your productivity</h3>
                          <p>Paraphrase more text at once to finish writing faster.</p>
                        </Box>
                      </Box>

                      <Box className={classes.premuimSliderBox}>
                        <img
                          src={`images/theme/${this.props.theme.palette.mode}/premiumPage/synonym.svg `}
                          className="lazyload"
                          alt="Synonyms"
                          style={{ maxWidth: '100%' }}
                        />
                        <Box className={classes.premuimSliderText}>
                          <h3>Access all modes</h3>
                          <p>Get maximum control over how you paraphrase.</p>
                        </Box>
                      </Box>

                      <Box className={classes.premuimSliderBox}>
                        <img
                          src="/images/theme/commonImages/plagiarismChecker/plag-premium.svg"
                          className="lazyload"
                          alt="Scan and Cite"
                          style={{ maxWidth: '100%' }}
                        />
                        <Box className={classes.premuimSliderText}>
                          <h3>Scan for plagiarism</h3>
                          <p>
                            Unlock the Plagiarism Checker to guarantee all sources are cited and
                            nothing is unintentionally plagiarized.
                          </p>
                        </Box>
                      </Box>

                      <Box className={classes.premuimSliderBox}>
                        <img
                          src={`images/theme/commonImages/premiumPage/comparisonTable.svg`}
                          className="lazyload"
                          alt="Compare modes"
                          style={{ maxWidth: '100%' }}
                        />
                        <Box className={classes.premuimSliderText}>
                          <h3>Compare all mode outputs at once</h3>
                          <p>Paraphrase and compare all seven modes at once.</p>
                        </Box>
                      </Box>
                    </AutoPlaySwipeableViews>
                    {/* <!-- ======== slider End from here ========== --> */}
                  </Grid>
                </Grid>
              </Hidden>

              <Hidden only={['xs', 'sm']}>
                <Grid item xs={12}>
                  <div className="container">
                    <Grid container style={{ marginBottom: '15px' }}>
                      <Grid item xs={6} style={{ textAlign: 'center' }}>
                        <img
                          src={PremiumFeatureTabImages(
                            this.props.theme.palette.mode,
                            this.state.premiumFeatureTabIndex
                          )}
                          className={`${classes.imgAnimation} lazyload`}
                          alt="available Words"
                        />
                      </Grid>
                      <Grid item xs={6} className={classes.tabHolderMain}>
                        <Box
                          className={`${classes.tabHolderBox} ${
                            premiumFeatureTabIndex === 0 ? classes.tabHolderBoxActive : ''
                          }`}
                          onClick={() =>
                            this.setState({
                              premiumFeatureTabIndex: 0,
                            })
                          }
                        >
                          <Typography variant="h3" color="primary">
                            Increase your productivity
                          </Typography>
                          <Typography color="textSecondary">
                            Paraphrase more text at once to finish writing faster.
                          </Typography>
                          <LinearProgress
                            showProgress={componentLoad && premiumFeatureTabIndex === 0}
                            duration={4950}
                          />
                        </Box>
                        <Box
                          className={`${classes.tabHolderBox} ${
                            premiumFeatureTabIndex === 1 ? classes.tabHolderBoxActive : ''
                          }`}
                          onClick={() =>
                            this.setState({
                              premiumFeatureTabIndex: 1,
                            })
                          }
                        >
                          <Typography variant="h3" color="primary">
                            Access all modes
                          </Typography>
                          <Typography color="textSecondary">
                            Get maximum control over how you paraphrase.
                          </Typography>
                          <LinearProgress
                            duration={4950}
                            showProgress={premiumFeatureTabIndex === 1}
                          />
                        </Box>
                        <Box
                          className={`${classes.tabHolderBox} ${
                            premiumFeatureTabIndex === 2 ? classes.tabHolderBoxActive : ''
                          }`}
                          onClick={() =>
                            this.setState({
                              premiumFeatureTabIndex: 2,
                            })
                          }
                        >
                          <Typography variant="h3" color="primary">
                            Scan for plagiarism
                          </Typography>
                          <Typography color="textSecondary">
                            Unlock the Plagiarism Checker to guarantee all sources are cited and
                            nothing is unintentionally plagiarized.
                          </Typography>
                          <LinearProgress
                            duration={4950}
                            showProgress={premiumFeatureTabIndex === 2}
                          />
                        </Box>
                        <Box
                          className={`${classes.tabHolderBox} ${
                            premiumFeatureTabIndex === 3 ? classes.tabHolderBoxActive : ''
                          }`}
                          onClick={() =>
                            this.setState({
                              premiumFeatureTabIndex: 3,
                            })
                          }
                        >
                          <Typography variant="h3" color="primary">
                            Compare all mode outputs at once
                          </Typography>
                          <Typography color="textSecondary">
                            Paraphrase and compare all seven modes at once.
                          </Typography>
                          <LinearProgress
                            duration={4950}
                            showProgress={premiumFeatureTabIndex === 3}
                          />
                        </Box>
                      </Grid>
                    </Grid>
                  </div>
                </Grid>
              </Hidden>
            </Grid>

            <div className={`${classes.premiumPageContainer} container`}>
              <Grid container>
                <Grid item xs={12} style={{ textAlign: 'center', marginTop: '46px' }}>
                  <h2 className={classes.sectionTitle}>Experience the full power of QuillBot </h2>
                </Grid>
                <PremiumVsFreeFeatureTableV1
                  signUpPathname={this.props.router.pathname}
                  isUserAuthenticated={this.props.user?.isAuthenticated || false}
                  isUserPremium={this.props.user.premium || false}
                />
              </Grid>
            </div>
            <PremiumModeSliders />

            <Grid container className={classes.premiumBottomSectionHolder}>
              <Grid item xs={12} className={classes.premiumBottomSection}>
                <div className="container">
                  <h2 style={{ fontWeight: 400, fontSize: '26px', marginBottom: '10px' }}>
                    Write better, faster, and clearer instantly
                  </h2>
                  <p style={{ maxWidth: '470px', margin: '0px auto 58px' }}>
                    QuillBot is trusted by students, professional writers, and business people who
                    want to write more effectively.
                  </p>
                </div>
                <LoadWithAnimation animationType="grow">
                  <Grid container>
                    <HerosectionNew />
                  </Grid>
                </LoadWithAnimation>
                <Grid item xs={12} style={{ textAlign: 'center' }}>
                  {!this.props.user?.premium && (
                    <>
                      <Link href={{ pathname: '/upgrade', query: { referrer: 'premiumPage' } }}>
                        <CircularGoldButton
                          variant="contained"
                          color="primary"
                          featured={0}
                          onClick={() => Track.upgradeLinkClicked('bottomSection')}
                          className={classes.premiumBtnBottom}
                        >
                          Upgrade to Premium
                        </CircularGoldButton>
                      </Link>
                    </>
                  )}
                </Grid>

                {!this.props.user?.availedRefund && (
                  <StyledTextContainer style={{ textAlign: 'center' }}>
                    <Typography variant={'h6'}>
                      100% Money-Back Guarantee <ThumbsUpIcon height="24px" width="24px" />
                    </Typography>
                    <Typography className={classes.assuranceDescription}>
                      Changed your mind? We’ll refund your payment within 3 days of purchase.
                    </Typography>
                  </StyledTextContainer>
                )}

                <StyledTextContainer style={{ textAlign: 'center' }}>
                  <Typography variant={'h6'}>
                    Pause Your Subscription <PauseIcon height="24px" width="24px" />
                  </Typography>
                  <Typography className={classes.assuranceDescription}>
                    Taking a break? Your subscription also pauses when you do!
                  </Typography>
                </StyledTextContainer>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </>
    );
  }
}
const mapStateToProps = (store: RootState) => ({
  user: store.user,
});
export default withTheme<Theme, React.FunctionComponent<{ theme: Theme }>>(
  connect(mapStateToProps)(withStyles(styles)(withRouter(PremiumPage as any)))
);
